<div>
  <p class="mb-4">
    Are there any pending
    <span
      class="btn--hyperlink cursor-pointer px-0"
      [routerLink]="GatherContractsRoutes.CHANGE_ORDER"
    >
      Change Orders?
    </span>
  </p>
</div>

<div class="mb-4 flex items-center">
  <div>
    <p>
      Are there any new or changing
      <span
        class="btn--hyperlink cursor-pointer px-0"
        [routerLink]="GatherContractsRoutes.PURCHASE_ORDERS"
      >
        Purchase Orders
      </span>
      ?
    </p>
  </div>

  <div class="gather-estimates-container ml-2">
    <!-- Upload section -->
    @if (!data.disabledLock) {
      <div class="gather-estimates-upload-section">
        <button
          type="button"
          class="btn--secondary pl-3"
          [disabled]="(hasPOPermission$ | async) === false"
          [auxTooltip]="
            (hasPOPermission$ | async) === false
              ? messagesConstants.DO_NOT_HAVE_PERMISSIONS_TO_ACTION
              : ''
          "
          (click)="data.addPoReportUploadClick()"
        >
          <aux-icon name="Plus" />
          <span class="ml-2">Add PO Report</span>
        </button>
      </div>
    }

    <!-- Upload-disabled section -->
    @if (data.disabledLock) {
      <div class="gather-estimates-upload-section">
        <button
          type="button"
          class="btn--secondary gather-estimates-upload-section-disabled pl-3"
          disabled
          [auxTooltip]="messagesConstants.LOCKED_FOR_PERIOD_CLOSE"
        >
          <aux-icon name="Plus" />
          <span class="ml-2">Add PO Report</span>
        </button>
      </div>
    }
  </div>
</div>

<div>
  <p class="mb-2">
    Are there any new
    <span class="btn--hyperlink cursor-pointer px-0" [routerLink]="GatherContractsRoutes.VENDORS">
      Vendor Contracts
    </span>
    or
    <span class="btn--hyperlink cursor-pointer px-0" [routerLink]="GatherContractsRoutes.BUDGET">
      Vendor Budget
    </span>
    updates?
  </p>
</div>
